import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { useResolvedFacility } from "@/hooks/use-selected-facility";
import { SetupTab } from "./setup-tab";

/**
 * Selected-facility configuration surface for Court Reservations. Operational
 * reservation search and actions are owned exclusively by `/bookings`.
 */
export function CourtReservationServiceHome() {
  const {
    facility,
    facilityId,
    isLoading: facilityLoading,
  } = useResolvedFacility();

  if (facilityLoading) {
    return (
      <Box
        role="status"
        sx={{
          minHeight: "40vh",
          display: "grid",
          placeItems: "center",
          px: { xs: 2, lg: 3 },
        }}
      >
        <Typography variant="body2" color="text.secondary">
          Loading…
        </Typography>
      </Box>
    );
  }

  if (!facilityId) {
    return (
      <Box role="status" sx={{ px: { xs: 2, lg: 3 }, py: 4 }}>
        <Typography variant="body2" color="text.secondary">
          Select a facility to configure reservations.
        </Typography>
      </Box>
    );
  }

  return (
    <Stack spacing={3} sx={{ px: { xs: 2, lg: 3 } }}>
      <Box>
        <Typography component="h1" variant="h5">
          Reservation setup
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {facility?.name ?? "Selected facility"}
        </Typography>
      </Box>

      <SetupTab facilityId={facilityId} />
    </Stack>
  );
}
